import type { LayoutStorage } from 'react-resizable-panels';

// why: `useDefaultLayout` defaults to the bare `localStorage` global and reads it for its
// why: server snapshot too, which throws under SSR — Node exposes the name and refuses the access.
export const resizableLayoutStorage: LayoutStorage = {
  getItem: (key) => (typeof window === 'undefined' ? null : window.localStorage.getItem(key)),
  setItem: (key, value) => {
    if (typeof window !== 'undefined') window.localStorage.setItem(key, value);
  },
};
